import { Injectable } from '@angular/core';
import { Observable, of, tap, catchError } from 'rxjs';
import { PreviewResource } from '../resource/preview.resource';
import { GraphNode } from '../interfaces/graph-node.interface';

@Injectable({ providedIn: 'root' })
export class PreviewService {
  private cache = new Map<string, GraphNode[]>();

  constructor(private resource: PreviewResource) {}

  /**
   * Get preview nodes for a map, with caching
   */
  getPreview(mapId: string): Observable<GraphNode[]> {
    const cached = this.cache.get(mapId);
    if (cached) {
      return of(cached);
    }

    return this.resource.getPreviewNodes(mapId).pipe(
      tap(nodes => this.cache.set(mapId, nodes)),
      catchError(() => of([]))
    );
  }

  /**
   * Clear the preview cache
   */
  clearCache(): void {
    this.cache.clear();
  }

  /**
   * Clear cached preview for a specific map
   */
  clearCacheForMap(mapId: string): void {
    this.cache.delete(mapId);
  }
}
